module.exports = __webpack_public_path__ + "img/imagen3.312e659f.png";